import { motion } from 'framer-motion';

interface PorcionPrecio {
  porciones: string;
  precio: number;
}

interface ProductCardProps {
  producto: {
    productoId: string;
    nombre: string;
    descripcion: string;
    precio?: number;
    precioTexto?: string;
    imageUrl?: string;
    porcionesPrecios?: PorcionPrecio[];
  };
}

const ProductCard = ({ producto }: ProductCardProps) => {
  const tienePorciones = producto.porcionesPrecios && producto.porcionesPrecios.length > 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      whileHover={{ y: -8 }}
      transition={{ duration: 0.3 }}
      className="card overflow-hidden hover:shadow-2xl transition-shadow duration-300 flex flex-col"
    >
      {producto.imageUrl && (
        <div className="aspect-square overflow-hidden -mx-6 -mt-6 mb-4">
          <img
            src={producto.imageUrl}
            alt={producto.nombre}
            className="w-full h-full object-cover"
          />
        </div>
      )}

      <h3 className="text-2xl font-serif text-milo-black mb-2">
        {producto.nombre}
      </h3>

      {producto.descripcion && (
        <p className="text-milo-gray mb-4 font-light leading-relaxed flex-grow">
          {producto.descripcion}
        </p>
      )}

      <div className="mt-auto pt-4 border-t border-milo-beige-dark space-y-3">
        {/* Precio principal (torta entera u otro) */}
        {producto.precio ? (
          <div className="flex items-baseline justify-between">
            <span className="text-sm text-milo-gray">
              {tienePorciones ? 'Torta entera' : ''}
            </span>
            <p className="text-xl font-medium text-milo-gold">
              ${producto.precio.toLocaleString()}
            </p>
          </div>
        ) : (
          <p className="text-lg text-milo-gray italic">
            {producto.precioTexto || 'Consultar precio'}
          </p>
        )}

        {/* Precios por porciones */}
        {tienePorciones && (
          <div className="space-y-1">
            <p className="text-xs font-medium text-milo-gray uppercase tracking-wide">
              Por porciones
            </p>
            {producto.porcionesPrecios!.map((pp, i) => (
              <div key={i} className="flex justify-between items-center text-sm">
                <span className="text-milo-gray">{pp.porciones} porciones</span>
                <span className="font-medium text-milo-gold">
                  ${pp.precio.toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProductCard;
